import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import Header from "../../Components/Header";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { deleteBanner, getBanners } from "../../reducers/commonReducer";
import BannerAction from "./BannerAction";
import { Button } from "react-bootstrap";
import { baseUrl } from "../../const";

const BannerList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBanners());
    if (!localStorage.getItem("x-auth-token")) {
      navigate("/");
    }
  }, []);
  const { getBannerData } = useSelector((state) => state.commonReducer);
  
  return (
    <>
      <Header />
      <div className="container">
        <Row className="mt-4 mb-2 user-table">
          <Col md={12}>
            <h3>Banners <span className="text-danger">(Please add max 4-5 Banners.)</span></h3>
          </Col>
          <hr />
          <Col md={6}>
            <BannerAction/>
          </Col>
        </Row>
        <div className="overflow-auto">
          <Table striped bordered hover size="sm" className="overflow-scroll">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Name</th>
                <th>OrderBy</th>
                <th>Image</th>
                <th>Mobile Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!!getBannerData &&
                getBannerData?.map((data, index) => {
                  return (
                    <tr key={data.id}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>{data?.orderby}</td>
                      <td className="table-img">
                      <img onClick={() => window.open(`${baseUrl}/${data?.image}`, '_blank')} src={data?.image} alt={data?.name}/>
                      </td>
                      <td className="table-img">
                      <img onClick={() => window.open(`${baseUrl}/${data?.mblimg}`, '_blank')} src={data?.mblimg} alt={data?.name}/>
                      </td>
                      <td>
                        <Button variant="danger" onClick={async() =>{
                          const userConfirmed = window.confirm('Are you sure you want to perform this action?');
                          if(userConfirmed){
                            await dispatch(deleteBanner(data?.id))
                            await dispatch(getBanners());
                          }
                        }}><i className="bi bi-trash-fill"></i></Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default BannerList;
